import { Controller } from '@hotwired/stimulus'

// LRPO-5818 — the tab badges are rendered once by the server and then go stale.
//
// "Select or unselect a rep, wait for auto-save" left the Assigned Reps badge on
// its page-load value while the screen said "All changes saved". The autosave is a
// fetch; nothing re-rendered the span. The save response now carries the counts and
// this controller applies them.
//
// ⚠ THESE BADGES LIVE INSIDE #exhibitor-form, WHICH THE AUTOSAVE OBSERVES. Writing
// to them is a DOM mutation, and an unguarded mutation there schedules another
// save, whose response writes the badge again — that is LRPO-5826, a full-form POST
// every 3 seconds forever. The badges carry `data-autosave-ignore`, which
// territory_autosave_controller checks before scheduling. Do not remove it.
//
// ⚠ textContent, never innerHTML: this is a server-supplied value.
export default class extends Controller {
  connect () {
    this._onSaved = event => this._apply(event.detail || {})
    document.addEventListener('territory:autosaved', this._onSaved)
  }

  disconnect () {
    document.removeEventListener('territory:autosaved', this._onSaved)
  }

  _apply (detail) {
    this._set('assigned-reps-count', detail.assigned_reps_count)
    // LRPO-5818 — the SAME number is shown twice: on the tab, and on the badge
    // beside the Assigned Reps table. Updating only one is how QA ended up
    // filming 7 and 4 on screen together.
    this._set('assigned-reps-panel-count', detail.assigned_reps_count)
    this._set('assigned-leads-count', detail.assigned_leads_count)
  }

  // ⚠ `== null` on purpose: a count of 0 is a real answer and must be written,
  // while an omitted count must leave a correct badge alone rather than blank it.
  _set (id, value) {
    if (value == null) return
    const el = document.getElementById(id)
    if (!el) return
    el.textContent = String(value)
  }
}
